import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, NavLink, Navigate } from 'react-router-dom';
import { Navbar, Container, Nav, Button, NavDropdown } from 'react-bootstrap';
import { useAuth } from './useAuth';
import LoginPage from './LoginPage';
import BookingPage from './BookingPage';
import AdminPage from './AdminPage';
import { Spinner } from 'react-bootstrap';
import { SharedStateProvider } from './SharedContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

const ProtectedRoute = ({ user, loading, role, children }) => {
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <Spinner animation="border" />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    if (role && user.role !== role) {
        return <Navigate to="/" replace />; // Redirect to a safe page if role doesn't match
    }
    return children;
};

function App() {
    const { user, loading, login, logout, theme, updateUserTheme } = useAuth();

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        updateUserTheme(newTheme);
    };

    return (
        <SharedStateProvider>
            <Router>
                <div className="App">
                    <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
                        <Container>
                            <Navbar.Brand as={Link} to="/">Scheduler</Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="me-auto">
                                    {user && <Nav.Link as={NavLink} to="/" end>Booking</Nav.Link>}
                                    {user?.role === 'admin' && <Nav.Link as={NavLink} to="/admin">Admin</Nav.Link>}
                                </Nav>
                                {user && (
                                    <Nav>
                                        <NavDropdown title={`Welcome, ${user.firstName}`} id="basic-nav-dropdown">
                                            <NavDropdown.Item onClick={toggleTheme}>
                                                Switch to {theme === 'light' ? 'Dark' : 'Light'} Mode
                                            </NavDropdown.Item>
                                            <NavDropdown.Divider />
                                            <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
                                        </NavDropdown>
                                    </Nav>
                                )}
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>

                    <Container>
                        <Routes>
                            <Route path="/login" element={<LoginPage onLogin={login} />} />
                            <Route
                                path="/"
                                element={
                                    <ProtectedRoute user={user} loading={loading}>
                                        <BookingPage user={user} />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute user={user} loading={loading} role="admin">
                                        <AdminPage user={user} />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to={user ? "/" : "/login"} />} />
                        </Routes>
                    </Container>
                    <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme={theme}
                    />
                </div>
            </Router>
        </SharedStateProvider>
    );
}

export default App;
